import { EditOutlined } from '@ant-design/icons';
import { gql, useMutation } from '@apollo/client';
import { Button, Modal, notification } from 'antd';
import React, { useCallback, useState } from 'react';

export const updateProjectSponsorshipMutation = gql`
  mutation ChangeSponsorshipThingModalA10(
    $projectSponsorship: ProjectSponsorshipUpdateInput!
  ) {
    updateProjectSponsorship(projectSponsorship: $projectSponsorship) {
      projectSponsorship {
        _id
      }
    }
  }
`;

function ChangeSponsorshipThingModalA10({
  projectSponsorship,
  children,
  btnProps,
  btnText,
}) {
  const [editing, setEditing] = useState();
  const handleEdit = useCallback(() => setEditing(true), []);
  const onDone = useCallback(() => setEditing(false), []);
  const onCancel = useCallback(() => setEditing(false), []);

  const [saving, setSaving] = useState(false);
  const [updateProjectSponsorship] = useMutation(
    updateProjectSponsorshipMutation,
  );

  const handleFinish = useCallback(
    async (values) => {
      setSaving(true);
      try {
        await updateProjectSponsorship({
          variables: {
            projectSponsorship: {
              _id: projectSponsorship._id,
              ...values,
            },
          },
        });
        notification.success({
          message: 'Success',
          description: 'Holistic Project Partnership saved successfully',
        });
        onDone();
      } catch (err) {
        console.error(err);
        notification.error({
          message: 'Error',
          description:
            'There was an error updating your Holistice Project Partnership',
        });
      }
      setSaving(false);
    },
    [projectSponsorship, updateProjectSponsorship, onDone],
  );
  return (
    <>
      <Modal
        open={editing}
        closable={false}
        destroyOnClose={true}
        maskClosable
        cancelText="Cancel"
        footer={null}
        onCancel={onCancel}
        // width={700}
        styles={{
          body: {
            paddingTop: 32,
          },
        }}
      >
        {React.cloneElement(children, {
          projectSponsorship,
          handleFinish,
          saving,
          onCancel,
        })}
      </Modal>
      <Button
        type="text"
        icon={<EditOutlined />}
        onClick={handleEdit}
        {...btnProps}
      >
        {btnText}
      </Button>
    </>
  );
}

export default ChangeSponsorshipThingModalA10;
